import { ExpensesEntitiesExpensableResourceTypeEnum } from 'generated/resources/graphql'
import { z } from 'zod'

import i18n from 'modules/core/lib/i18n'

import { CustomizationField, isMandatory } from 'modules/expenses/hooks/useExpensesCustomization'

interface FormContext {
  customizationFields: CustomizationField[]
  resourceType: ExpensesEntitiesExpensableResourceTypeEnum
  isNewPerDiem?: boolean
}

const defaultRequiredMessage = () => ({
  message: i18n.t('expenses_v2.forms.errors.required'),
})

export const DateTimeSchema = ({
  customizationFields,
  resourceType,
  isNewPerDiem,
}: FormContext) => {
  return z.object({
    start_date: z
      .string()
      .optional()
      .nullable()
      .refine(
        (start_date) =>
          isNewPerDiem
            ? true
            : isMandatory('start_date', resourceType, customizationFields)
              ? !!start_date
              : true,
        defaultRequiredMessage()
      ),
    end_date: z
      .string()
      .optional()
      .nullable()
      .refine(
        (end_date) =>
          isNewPerDiem
            ? true
            : isMandatory('end_date', resourceType, customizationFields)
              ? !!end_date
              : true,
        defaultRequiredMessage()
      ),
  })
}

export type DateTimeSchema = z.infer<ReturnType<typeof DateTimeSchema>>
